import Ventana from "../../../isp._comun/iu/_principal/reductores/Ventana";
import { DialogType, ModosOp } from "../../../isp._comun/iu/_principal/constantesIuPrin";
import getEstadoInicial from "../EstadoDialogoZona";

export default class VentanaZona extends Ventana {
    constructor(estadoComp) {
        super();
        this.id= DialogType.ZONA+estadoComp.domain.screen.idZona;
        this.estadoComp = estadoComp;
    }

    static nuevaVentanaEnModoCrear() {
        return new VentanaZona(getEstadoInicial());
    }

    static nuevaVentanaEnModoOk(idZona) {
        const estadoComp = getEstadoInicial();
        estadoComp.flag.modoOperacion = ModosOp.OK;
        estadoComp.domain.screen.idZona = idZona;
        estadoComp.flag.modal = true;
        estadoComp.flag.cargandoEntidad = true;
        return new VentanaZona(estadoComp);
    }

    puedeHacersePasarPor(ventanaAAbrir) {
        if (!(ventanaAAbrir instanceof VentanaZona)) {
            return false;
        }
        if(this.id === ventanaAAbrir.id){
            return true;
        }
        return false;
    }

    clonar() {
        const nuevaVentana = new VentanaZona(this.estadoComp);
        nuevaVentana.posicionZ = this.posicionZ;
        return nuevaVentana;
    }
}
